import React, { useEffect, useState } from "react";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import moment from "moment-jalaali";

import "../style.scss";
import { ReactComponent as CommentIcon } from "./../../../../src/asset/icons/comments.svg";
import PaginationComponent from "../../../component/global/PaginationComponent";
import { ReactComponent as CalendarIcon } from "../../../../src/asset/icons/cal.svg";
import { ReactComponent as Time } from "../../../../src/asset/icons/time.svg";
import { getTextDigest } from "../../../utils/methods";
import { get } from "../../../controlers/global/ConfigRequest";
// import { ReactComponent as Time } from "../../../../src/asset/icons/time.svg";
import { ReactComponent as AttachIcon } from "../../../../src/asset/icons/attachIcon.svg";
import {
    FEEDBACK_STATUS_REPORT,
    USER_FEEDBACK_STATUS_REPORT,
} from "../../../helperData/ApiAddress";
import { useTranslation } from "react-i18next";

const Card = ({
    index,
    firstName,
    lastName,
    group,
    workplace,
    datetime,
    description,
    file,
    operatorGroup,
    action,
}) => {
    const { t } = useTranslation();
    const renderTooltips = (props) => (
        <Tooltip id="message-tooltip" {...props}>
            {description}
        </Tooltip>
    );
    let backgroundColor = [null, "#B2DFDB", "#FFE0B2", "#FFCDD2"];

    return (
        <div className="report_card_main" dir="rtl">
            <div
                className="row_nu"
                style={{ backgroundColor: backgroundColor[action] }}
            >
                {index + 1}
            </div>
            <div className="user_info_main">
                <div className="user_info">
                    <span>
                        {workplace ||
                            t("Src.Pages.Messages.Modals.Report.Level")}
                    </span>
                    <span>
                        {firstName ||
                            t("Src.Pages.Messages.Modals.Report.User")}{" "}
                        {lastName ||
                            t("Src.Pages.Messages.Modals.Report.Guest")}
                    </span>
                    <span>{operatorGroup || ""}</span>
                </div>
            </div>
            <div className="user_group_st">
                {action === 1 && (
                    <>
                        <span>
                            {t(
                                "Src.Pages.Messages.Modals.Report.Remove.Message"
                            )}
                        </span>
                    </>
                )}
                {action === 2 && (
                    <>
                        <span>
                            {t("Src.Pages.Messages.Modals.Report.Send.Group")}
                        </span>
                        <span>{group}</span>
                    </>
                )}
                {action === 3 && (
                    <>
                        <span>
                            {t(
                                "Src.Pages.Messages.Modals.Report.Closed.Message"
                            )}
                        </span>
                    </>
                )}
            </div>
            <div className="user_group_st" style={{ width: 100 }}>
                {action === 1 && (
                    <>
                        <span>
                            {t("Src.Pages.Messages.Modals.Report.Remove")}
                        </span>
                    </>
                )}
                {action === 2 && (
                    <>
                        <span>
                            {t("Src.Pages.Messages.Modals.Report.Replay")}
                        </span>
                    </>
                )}
                {action === 3 && (
                    <>
                        <span>
                            {t("Src.Pages.Messages.Modals.Report.Close")}
                        </span>
                    </>
                )}{" "}
            </div>
            <div className="date_time_st info_st">
                <CalendarIcon />
                <span className="details_value">
                    {moment(datetime).format("jYYYY/jMM/jDD")}
                </span>
                <Time />
                <span className="date_type">
                    {moment(datetime).format("HH:mm")}
                </span>
            </div>
            <div className="des_st info_st">
                {action !== 1 ? (
                    <OverlayTrigger
                        placement={description.length < 60 ? "top" : "bottom"}
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltips}
                    >
                        <div className="des_st">
                            <CommentIcon />
                            {description !== "" ? (
                                <span>{getTextDigest(description)}</span>
                            ) : (
                                <span className="empty-des">
                                    {t(
                                        "Src.Pages.Messages.Modals.Report.No.Message"
                                    )}
                                </span>
                            )}
                        </div>
                    </OverlayTrigger>
                ) : (
                    <OverlayTrigger
                        placement={description.length < 60 ? "top" : "bottom"}
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltips}
                    >
                        <div className="des_st">
                            <CommentIcon />
                            <span className="empty-des">
                                {t(
                                    "Src.Pages.Messages.Modals.Report.Alert.Message"
                                )}
                            </span>
                        </div>
                    </OverlayTrigger>
                )}
            </div>

            <div className="progress_st">
                {
                    <button
                        download
                        onClick={() => window.open(file, "_blank")}
                        style={{ visibility: file ? "visible" : "hidden" }}
                    >
                        <AttachIcon />
                    </button>
                }
            </div>
        </div>
    );
};

const Report = ({ feedbackId, userType }) => {
    const [reportLoader, setReportLoader] = useState(true);
    const [report, setReport] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        if (feedbackId) {
            setReportLoader(true);
            const API =
                userType === "organ"
                    ? FEEDBACK_STATUS_REPORT
                    : USER_FEEDBACK_STATUS_REPORT;
            get(API.replace("{id}", feedbackId)).then((r) => {
                setReport(r.results);
                setReportLoader(false);
            });
        }
    }, [feedbackId]);

    if (reportLoader === true) {
        return (
            <div className="report-spinner">
                <Spinner animation="border" />
            </div>
        );
    }

    return (
        <div className="report_content modal_main_content">
            <div className="report-container">
                <div className="modal_card_main report-section">
                    {report.length === 0 ? (
                        <div
                            style={{
                                textAlign: "right",
                                fontSize: 12,
                                color: "#ccc",
                            }}
                        >
                            {t("Organizational.Messages.NoReports.Label")}
                        </div>
                    ) : (
                        <>
                            <div className="report_card_main header" dir="rtl">
                                <div
                                    className="row_nu"
                                    style={{ backgroundColor: "transparent" }}
                                >
                                    &nbsp;
                                </div>
                                <div className="user_info_main">
                                    <span>
                                        {t(
                                            "Src.Pages.Messages.Modals.Report.Table.User.Source"
                                        )}
                                    </span>
                                </div>
                                <div className="user_group_st">
                                    <span>
                                        {t(
                                            "Src.Pages.Messages.Modals.Report.Table.User.Destination"
                                        )}
                                    </span>
                                </div>
                                <div
                                    className="user_group_st"
                                    style={{ width: 100 }}
                                >
                                    <span>
                                        {t(
                                            "Src.Pages.Messages.Modals.Report.Table.Type"
                                        )}
                                    </span>
                                </div>
                                <div className="date_time_st info_st">
                                    <span>
                                        {t(
                                            "Src.Pages.Messages.Modals.Report.Table.Date"
                                        )}
                                    </span>
                                </div>
                                <div className="des_st info_st">
                                    <span>
                                        {t(
                                            "Src.Pages.Messages.Modals.Report.Table.Message"
                                        )}
                                    </span>
                                </div>

                                <div className="progress_st">&nbsp;</div>
                            </div>
                            {report?.map((r, index) => (
                                <Card
                                    firstName={r.operator.first_name}
                                    lastName={r.operator.last_name}
                                    workplace={r.operator.role}
                                    description={r.description}
                                    file={r.file}
                                    datetime={r.datetime}
                                    group={r.group?.name}
                                    operatorGroup={r.operator_group?.name}
                                    index={index}
                                    action={r.action}
                                />
                            ))}
                        </>
                    )}
                </div>
            </div>
            <div className="messages_content_bottom">
                <PaginationComponent />
            </div>
        </div>
    );
};

export default Report;
